import useLazyData from '@/hooks/useLazyData';
import dynamic from 'next/dynamic';
import Skeleton, { NavigationLineSkeletonV2 } from './skeleton';

const DynamicNavigationLine = dynamic(() => import('./navigation-line'), {
  ssr: false,
  loading: Skeleton
});

const DynamicNavigationLineV2 = dynamic(() => import('./navigation-line-v2'), {
  ssr: false,
  loading: NavigationLineSkeletonV2
});

const NavigationLine = props => {
  const { ref: viewRef, show } = useLazyData({
    threshold: 0.01,
    rootMargin: '10px 0px 0px 0px'
  });

  let isV2 = props.properties?.style === 'v2';

  const skeleton = isV2 ? <NavigationLineSkeletonV2 /> : <Skeleton />;

  if (!show) {
    return <div ref={viewRef}>{skeleton}</div>;
  }

  if (isV2) {
    return <DynamicNavigationLineV2 skeleton={skeleton} {...props} />;
  }

  return <DynamicNavigationLine skeleton={skeleton} {...props} />;
};

export default NavigationLine;
